import React, { useEffect, useState } from 'react';
import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';

// pages
import LoginPage from './pages/LoginPage';
import Page404 from './pages/Page404';
import DashboardAppPage from './pages/DashboardAppPage';
import ZakazkyListPage from './pages/zakazky/ZakazkyList.page';
import PartieListPage from './pages/partie/PartieList.page';
import ZakazkyDetail from './pages/zakazky/ZakazkyDetail.page';
import Profile from './pages/Profile.page';

import { useAuth } from './hooks/useAuth';

// ----------------------------------------------------------------------

export const PrivateRoutes = () => {
  const routes = useRoutes([
    {
      path: 'dashboard',
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to="/dashboard/" />, index: true },
        { path: 'app', element: <DashboardAppPage /> },
        { path: 'zakazky', element: <DashboardAppPage /> },
        { path: 'stavby', element: <DashboardAppPage /> },
        { path: 'mapa', element: <DashboardAppPage /> },
      ],
    },
    {
      path: 'profile',
      element: <DashboardLayout />,
      children: [{ element: <Profile />, index: true }],
    },
    {
      path: 'Sprava',
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to="/sprava/" />, index: true },
        {
          path: 'zakazky',
          element: <ZakazkyListPage />,
        },
        {
          path: 'zakazky/detail/:id',
          element: <ZakazkyDetail />,
        },
        { path: 'partie', element: <PartieListPage /> },
      ],
    },
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="/dashboard/app" />, index: true },
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to="/dashboard/app" /> },
      ],
    },
  ]);

  return routes;
};

export const PublicRoutes = () => {
  const routes = useRoutes([
    {
      path: 'login',
      element: <LoginPage />,
      children: [{ element: <Navigate to="login" />, index: true }],
    },
    { path: '404', element: <Page404 /> },
    { path: '*', element: <Navigate to="/login" /> },
  ]);
  return routes;
};

const Router = () => {
  const [loading, setLoading] = useState(true);
  const { user, auth } = useAuth();

  const loadUser = async () => {
    const token = localStorage.getItem('token');
    if (token) {
      await auth(token);
    }
    setLoading(false);
  };
  useEffect(() => {
    loadUser();
  }, []);

  return <>{!loading && (user ? <PrivateRoutes /> : <PublicRoutes />)}</>;
};

export default Router;
